import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { IoEyeOutline } from "react-icons/io5";
import _ from "lodash";
import {
  CRUDLayout,
  Alert,
  DataStatus,
  ActionButton,
  UpdateButton,
  ReadButton,
  InputSearch,
  Pagination,
  Table,
  Th,
  Td,
  ThFixed,
  TdFixed,
  CreateButton,
  ApprovalStatusButton,
  FilterButton,
} from "components";
import { DateConvert, DecimalConvert, TableNumber } from "utilities";
import { ConvertItepApi } from "api";
import { CollapesItem, ModalDetail, ModalFilter } from "./Section";

const ListConvertItem = ({ setNavbarTitle }) => {
  const history = useHistory();
  const location = useLocation();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [dataSuratJalan, setDataSuratJalan] = useState([]);
  const [showModalFilter, setShowModalFilter] = useState(false);
  const [dataFilter, setDataFilter] = useState({
    filter: {
      active: location?.state?.surat_jalan?.filter?.active,
      tgl_convert_item_master_mulai:
        location?.state?.surat_jalan?.filter?.tgl_convert_item_master_mulai,
      tgl_convert_item_master_selesai:
        location?.state?.surat_jalan?.filter?.tgl_convert_item_master_selesai,
      id_item_convert: location?.state?.surat_jalan?.filter?.id_item_convert,
      id_gudang: location?.state?.surat_jalan?.filter?.id_gudang,
    },
    pagination: {
      page: location?.state?.surat_jalan?.filter?.page ?? "1",
      dataLength: location?.state?.surat_jalan?.filter?.dataLength ?? "10",
      totalPage: location?.state?.surat_jalan?.filter?.totalPage ?? "1",
      dataCount: location?.state?.surat_jalan?.filter?.dataCount ?? "0",
    },
  });
  const [searchConfig, setSearchConfig] = useState({
    status: false,
    key: "",
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });

  const [searchTime, setSearchTime] = useState(null);
  const [modalConfigDetail, setModalConfigDetail] = useState({
    show: false,
    id: "",
  });

  const getInitialData = () => {
    setIsPageLoading(true);

    ConvertItepApi.get({
      q: searchConfig.key,
      page: dataFilter?.pagination?.page,
      per_page: dataFilter?.pagination?.dataLength,
      tgl_convert_item_master_mulai:
        dataFilter?.filter?.tgl_convert_item_master_mulai,
      tgl_convert_item_master_selesai:
        dataFilter?.filter?.tgl_convert_item_master_selesai,
      id_item_convert: dataFilter?.filter?.id_item_convert,
      id_gudang: dataFilter?.filter?.id_gudang,
    })
      .then((data) => {
        setDataSuratJalan(data?.data?.data ?? []);
        setDataFilter({
          ...dataFilter,
          pagination: {
            ...dataFilter.pagination,
            dataCount: data?.data?.data_count,
            totalPage: data?.data?.total_page,
          },
        });
      })
      .catch((err) => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!",
        });
      })
      .finally(() => setIsPageLoading(false));
  };

  const checkAlert = () => {
    const locationState = location.state;

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant,
        });
      }
    }
  };

  const onInputSearch = (text) => {
    const key = text.target.value;
    if (searchTime) clearTimeout(searchTime);
    setSearchTime(
      setTimeout(() => {
        setSearchConfig({
          ...searchConfig,
          key: key,
        });
        setAlertConfig({
          show: key ? true : false,
          variant: "primary",
          text: "Hasil dari pencarian: " + key,
        });
      }, 750)
    );
  };

  useEffect(() => {
    setNavbarTitle("Convert Item");
    getInitialData();
    checkAlert();

    return () => {
      setIsPageLoading(false);
    };
  }, [
    searchConfig.key,
    dataFilter?.pagination?.page,
    dataFilter?.pagination?.dataLength,
    dataFilter?.filter?.active,
    dataFilter?.filter?.tgl_convert_item_master_mulai,
    dataFilter?.filter?.tgl_convert_item_master_selesai,
    dataFilter?.filter?.id_item_convert,
    dataFilter?.filter?.id_gudang,
    dataFilter?.filter?.status_approval,
  ]);

  const PageContent = () => {
    const checkStatus = (stat) => {
      const data = stat ? stat.toUpperCase() : "";
      const convert = data.substring(0, 3);

      if (convert === "APP")
        return {
          variant: "outline-success",
          label: "APPROVED",
        };
      // return "APPROVED";
      if (convert === "VER")
        return {
          variant: "outline-verified",
          label: "VERIFIED",
        };
      // return "VERIFIED";
      if (convert === "REV")
        return {
          variant: "outline-revised",
          label: "REVISION",
        };
      // return "REVISI";
      if (convert === "REJ")
        return {
          variant: "outline-danger",
          label: "REJECTED",
        };
      // return "REJECT";

      return {
        variant: "outline-secondary",
        label: "PENDING",
      };
      // return "PENDING";
    };

    const DataTable = () => (
      <>
        <span style={{ fontSize: "14px" }}>
          <b>List Data Convert Item</b>
        </span>
        <Table>
          <thead>
            <tr>
              <ThFixed>No</ThFixed>
              <ThFixed>Aksi</ThFixed>
              <ThFixed>Informasi Convert Item</ThFixed>
              <Th>Item Convert</Th>
              <Th>Item Campuran</Th>
              <Th>Gudang</Th>
            </tr>
          </thead>
          <tbody>
            {dataSuratJalan.map((val, index) => (
              <tr key={index}>
                <TdFixed>
                  {TableNumber(
                    dataFilter?.pagination?.page,
                    dataFilter?.pagination?.dataLength,
                    index
                  )}
                </TdFixed>
                <Td className="d-flex">
                  <ReadButton
                    onClick={() =>
                      setModalConfigDetail({
                        show: true,
                        id: val.id_convert_item_master,
                      })
                    }
                  />
                </Td>
                <TdFixed>
                  <div className="text-left">
                    {val.tgl_convert_item_master
                      ? DateConvert(new Date(val.tgl_convert_item_master))
                          .defaultDMY
                      : "-"}
                  </div>
                  <div className="text-left">
                    {val.no_convert_item_master ?? "-"}
                  </div>
                </TdFixed>
                <Td>{`${val.nama_item ?? "-"} ${
                  DecimalConvert(parseFloat(val.qty_convert ?? 0)).getWithComa
                } ${val.satuan_pakai ?? "-"}`}</Td>
                <Td>
                  {val.item_campuran ? (
                    val.item_campuran.length > 0 ? (
                      <CollapesItem data={val.item_campuran} />
                    ) : (
                      "-"
                    )
                  ) : (
                    "-"
                  )}
                </Td>
                <Td>{val.nama_gudang ?? "-"}</Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    );

    if (!dataSuratJalan || dataSuratJalan.length < 1) {
      return <DataStatus text="Tidak ada data" />;
    }

    return (
      <>
        <DataTable />
        {!searchConfig.status && (
          <Pagination
            dataLength={dataFilter?.pagination?.dataLength}
            dataNumber={
              dataFilter?.pagination?.page *
                dataFilter?.pagination?.dataLength -
              dataFilter?.pagination?.dataLength +
              1
            }
            dataPage={
              dataFilter?.pagination?.dataCount <
              dataFilter?.pagination?.dataLength
                ? dataFilter?.pagination?.dataCount
                : dataFilter?.pagination?.page *
                  dataFilter?.pagination?.dataLength
            }
            dataCount={dataFilter?.pagination?.dataCount}
            currentPage={dataFilter?.pagination?.page}
            totalPage={dataFilter?.pagination?.totalPage}
            onPaginationChange={({ selected }) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: selected + 1,
                },
              })
            }
            onDataLengthChange={(e) =>
              setDataFilter({
                ...dataFilter,
                pagination: {
                  ...dataFilter.pagination,
                  page: 1,
                  dataLength: e.target.value,
                },
              })
            }
          />
        )}
      </>
    );
  };

  return (
    <CRUDLayout>
      {/* Head Section */}
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch onChange={onInputSearch} />
            <FilterButton
              active={dataFilter?.filter?.active}
              onClick={() => setShowModalFilter(true)}
            />
          </div>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection>
          <CreateButton
            onClick={() =>
              history.push("/inventory/transaksi/convert-item/tambah", {
                ...location?.state,
                surat_jalan: dataFilter,
                action: "ADD",
              })
            }
          />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* Alert */}
      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
      />

      {/* Content */}
      {isPageLoading ? (
        <DataStatus loading={true} text="Memuat data . . ." />
      ) : (
        <PageContent />
      )}
      {showModalFilter && (
        <ModalFilter
          show={showModalFilter}
          setShow={setShowModalFilter}
          data={dataFilter}
          setData={setDataFilter}
        />
      )}
      {modalConfigDetail.show && (
        <ModalDetail
          setModalConfigDetail={setModalConfigDetail}
          modalConfigDetail={modalConfigDetail}
        />
      )}
    </CRUDLayout>
  );
};

export default ListConvertItem;
